export function formatBaht(amount: number) {
  return `${Math.floor(amount).toLocaleString()} บาท`
}
